// extracted by mini-css-extract-plugin
module.exports = {"truncate1":"truncate_truncate1__SXopq","truncate3":"truncate_truncate3__BoczB","truncate4":"truncate_truncate4__Tmi_4","truncate6":"truncate_truncate6__colGp"};